/**
 * SOULBIKE — carrusel horizontal genérico (home).
 * Flechas, arrastre con el mouse y scroll nativo con snap. El táctil lo resuelve
 * el navegador solo. Sin JS el track sigue siendo scrolleable de lado.
 */
(function () {
  'use strict';

  function montar(zona) {
    var track = zona.querySelector('[data-sb-slider-track]');
    if (!track) return;
    var prev = zona.querySelector('[data-sb-slider="prev"]');
    var next = zona.querySelector('[data-sb-slider="next"]');

    function paso() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return (card.getBoundingClientRect().width + gap) * 2;
    }
    function pintar() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
    track.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar, { passive: true });

    // arrastre con el mouse: en desktop nadie espera usar la rueda lateral
    var abajo = false, x0 = 0, s0 = 0, movido = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      abajo = true; movido = 0; x0 = e.clientX; s0 = track.scrollLeft;
      track.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!abajo) return;
      var d = e.clientX - x0;
      movido = Math.max(movido, Math.abs(d));
      track.scrollLeft = s0 - d;
    });
    window.addEventListener('pointerup', function () {
      if (!abajo) return;
      abajo = false; track.classList.remove('is-drag');
    });
    // un arrastre no debe abrir la ficha del producto
    track.addEventListener('click', function (e) {
      if (movido > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    pintar();
  }

  function init() {
    document.querySelectorAll('[data-sb-slider-track]').forEach(function (t) {
      var zona = t.closest('section') || t.parentElement;
      if (zona && !zona.dataset.sbSliderOn) { zona.dataset.sbSliderOn = '1'; montar(zona); }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
